<template>
  <div class="referral-earnings-list">
    <template v-for="(type, index) in allTokenTypes">
      <divider-line
        v-if="index > 0"
        :key="`divider-${index}`"
        :isHighligted="isTokenGrantedByReferral(referralDetails.id,type)">
      </divider-line>

      <earned-item
        :key="`earning-${index}`"
        :type="type"
        :value="getEarningValue(type)"
        :status="getEarningStatus(type)"
        :isActive="isTokenGrantedByReferral(referralDetails.id, type)">
      </earned-item>
    </template>
  </div>
</template>

<script>

import {isEmpty} from 'lodash';
import {BRONZE, ORANGE, SILVER} from 'top20common/distribution/constants/tokens';
import currencies from 'top20common/distribution/services/currencies';
import {mapGetters} from 'vuex';

import {STATUS_PENDING} from '@/utils/constants/referrals';
import tokensHelper from '@/utils/tokens-helper';

import DividerLine from './DividerLine';
import EarnedItem from './EarnedItem';

export default {
  computed: {
    ...mapGetters([
      'referralDetailsBySlugState',
      'tokensByReferralIdState',
      'isTokenGrantedByReferral',
      'tokensMetaState'
    ]),
    referralSlug() {
      return this.$route.params.slug;
    },
    referralDetails() {
      return this.referralDetailsBySlugState[this.referralSlug] || {};
    },
    earnedTokens() {
      return this.tokensByReferralIdState[this.referralDetails.id] || [];
    },
    allTokenTypes() {
      return tokensHelper.getTokenTypes();
    },
    hiredReward() {
      if (isEmpty(this.referralDetails)) {
        return '';
      }

      let earnedFrom = currencies.getShortFormatNumberWithCurrency(this.referralDetails.total_earn_from);
      let earnedTo = currencies.getShortFormatNumber(this.referralDetails.total_earn_to, 1);
      return `${earnedFrom}-${earnedTo}`;
    },
    totalReferralEarnings() {
      return this.formatEarnings(this.referralDetails.earned);
    },
    earningValueOrangeToken() {
      return this.isTokenGrantedByReferral(this.referralDetails.id, ORANGE)
        ? this.formatEarnings(this.earnedTokens.filter(token => token.type === ORANGE)[0].amount)
        : this.hiredReward;
    }
  },
  methods: {
    getDefaultEarning(type) {
      let keys = {
        [BRONZE]: 'bronze_token_value',
        [SILVER]: 'silver_token_value'
      };
      let earningKey = keys[type];

      return this.tokensMetaState[earningKey];
    },
    getEarningValue(type) {
      return type === ORANGE ? this.earningValueOrangeToken : this.formatEarnings(this.getDefaultEarning(type));
    },
    formatEarnings(value) {
      return currencies.getFormattedCurrencyFullValue(currencies.getCurrentCurrency(), value, 0, 0);
    },
    isTokenTypePending(type) {
      return this.earnedTokens.filter(token => !token.id && token.type === type).length;
    },
    getEarningStatus(type) {
      return this.isTokenTypePending(type) ? STATUS_PENDING : tokensHelper.getStatusByTokenType(type);
    }
  },
  components: {EarnedItem, DividerLine}
};
</script>

<style lang="scss" scoped>
.referral-earnings-list {
  display: flex;
  padding: 0 10px;
}
</style>
